import React from "react";
import "./PreviewTable.css";

interface PreviewTableProps {
  previewData: any[] | null | undefined;
  isQAEnabled: boolean;
  onRowClick?: (rowData: any) => void;
  selectedRowData?: any;
  setSelectedRowData?: (rowData: any) => void;
}

const PreviewTable: React.FC<PreviewTableProps> = ({ previewData, isQAEnabled, onRowClick, selectedRowData, setSelectedRowData }) => {
  
  const getStatusClass = (status: string) => {
    switch (status.toLowerCase()) {
      case "approved":
        return "status-approved";
      case "under_review":
        return "status-under-review";
      case "in_progress":
        return "status-in-progress";
      case "not_found":
        return "status-not-found";
      case "note_started":
        return "status-not-started"
      case "processing":
        return "status-processing";
      default:
        return "status-default";
       
    }
  };



  const handleRowClick = (row: any) => {
    if (isQAEnabled) {
      if (setSelectedRowData) {
        setSelectedRowData(row);
      }
      if (onRowClick) {
        onRowClick(row);
      }
    }
  }

  if (!previewData || previewData.length === 0) {
    return (
      <div className="table-container">
        <p>No data available for preview</p>
      </div>
    );
  }
  const columns = isQAEnabled ? ["question", "approved_by", "status"] : Object.keys(previewData[0]);

return (
  <div className="table-container">
    
    <div className="table-wrapper">
      <table className="table-body">
        <thead>
          <tr className="table-header-row">
            <th></th>
            {columns.map((key) => (
              <th key={key}>{key === 'approved_by' ? 'Approved By' : key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {previewData.map((row, idx) => (
            <tr
              key={idx}
              className="table-row"
              style={{ cursor: isQAEnabled ? "pointer" : "default" }}
              onClick={isQAEnabled ? () => handleRowClick(row) : undefined}
            >
              <td
                style={selectedRowData && isQAEnabled && row.id === selectedRowData.id ? { fontWeight: "600", background: "#f8fbff" } : {}}
              >
                {idx + 1}
              </td>
              {columns.map((key) => {
                const cellStyle = selectedRowData && isQAEnabled && row.id === selectedRowData.id ? { fontWeight: "600", background: "#f8fbff" } : {};
                let cellContent: any = null;
                if (key === "status") {
                  cellContent = <span className="status-badge">{(row[key] || "").toString().replace("_", " ")}</span>;
                } else if (key === 'approved_by' || key === 'approver_id') {
                  cellContent = row?.approver_id?.approved_name || row?.approved_name || row?.approved_by || "";
                } else {
                  cellContent = row[key];
                }

                return (
                  <td
                    key={key}
                    className={key === "status" ? getStatusClass((row && row[key]) || "") : ""}
                    style={cellStyle}
                  >
                    {cellContent}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

};

export default PreviewTable;
